








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Container extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly cursor!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly noTopMargin!: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/form/components/select/components/container/Container.vue